<lot-unit-table heading="Barcodes" keyHeader="Barcode" [rows]="this.rows" [leadColumns]="this.leadColumns" [pageSize]="10">
  <button mat-stroked-button type="button" (click)="bulkAction()" [disabled]="!this.rows.length">Bulk Action</button>
</lot-unit-table>

<ng-template #statusTemplate let-data>
  <span *ngIf="data.status" class="status-tag" [ngClass]="statusClass(data.status)">
    <span class="status-dot"></span>{{data.status}}
  </span>
</ng-template>
